import UltMeta, { Meta } from "@/meta/UltMeta";
import { isEmpty } from "lodash-es";
import { getValueByPath } from "@/utils/object";
import { DEFAULT_VALUE } from "@/config";
import type { ShareOperationRecordDetail, ShareStatisticsVo } from "@zhihaoscm/entity";

export enum TABS {
    // 需求
    DEMAND = 1,
    // 空船
    EMPTY_SHIP = 2
}

export interface BaseItemConfig {
    label: string;
    prop: string;
    col?: number;
    span?: number;
    formatter?: (value: any) => string;
    click?: ((value?: string | number | undefined) => void) | undefined;
}

export interface CustomShareOperationRecordDetail extends ShareOperationRecordDetail {
    _index: number;
}

// 获取格式化后的值
export const getFormatterValue = (item: BaseItemConfig, data: ShareStatisticsVo): string => {
    if (isEmpty(data)) return DEFAULT_VALUE;
    const value = getValueByPath(data as unknown as Record<string, unknown>, item?.prop);
    return item.formatter ? item.formatter(value) : ((value as string) ?? DEFAULT_VALUE);
};

export const TABS_TITLE_MAP = {
    [TABS.DEMAND]: {
        sub: "列表数据为船务APP、小程序、管理后台用户使用需求分享功能及后续目标用户查看、报价需求相关操作的埋点数据"
    },
    [TABS.EMPTY_SHIP]: {
        sub: "列表数据为船务APP、小程序、管理后台用户使用空船分享功能及后续目标用户查看的埋点数据"
    }
};

/**
 * 需求跳转路径
 */
class JumpPath extends UltMeta {
    /**
     * 需求详情
     */
    SHIPPING_DEMAND_DETAIL = new Meta(1, "船主端需求详情");
    /**
     * 找船运单详情
     */
    OWNER_DEMAND_DETAIL = new Meta(2, "货主端需求详情");
}
export const JUMP_PATH = new JumpPath();
